export function index(type = null)
{
    return axios.get(route('api.manage.companies.emailTemplates') + '?include=attachments' + (type ? '&filter[type]=' + type : ''))
        .then(response => response.data);
}

export function show(templateId)
{
    return axios.get(route('api.manage.emailTemplates.show', { templateId: templateId }));
}

export function store(data)
{
    return axios.post(route('api.manage.companies.emailTemplates') + '?include=attachments' , data)
        .then(response => response.data);
}

export function update(templateId, data)
{
    return axios.patch(route('api.manage.emailTemplates.update', { templateId: templateId }) + '?include=attachments' , data)
        .then(response => response.data);
}

export function destroy(templateId)
{
    return axios.delete(route('api.manage.emailTemplates.destroy', { templateId: templateId }));
}

export function duplicate(templateId)
{
    return axios.post(route('api.manage.emailTemplates.duplicate', { templateId: templateId }));
}

export function updateOrder(oldIndex, newIndex, type) {
    return axios.post(route('api.manage.companies.emailTemplates.updateOrder'), {
        oldIndex: oldIndex,
        newIndex: newIndex,
        type: type,
    });
}
